module.exports = {
          srcSet: __webpack_public_path__ + "211e99d3866dbb10d2babf79413cb890-377.png"+" 377w",
          images:[ {path: __webpack_public_path__ + "211e99d3866dbb10d2babf79413cb890-377.png",width: 377,height: 380}],
          src: __webpack_public_path__ + "211e99d3866dbb10d2babf79413cb890-377.png",
          toString:function(){return __webpack_public_path__ + "211e99d3866dbb10d2babf79413cb890-377.png"},
          
          width: 377,
          height: 380
        }